export const COOKIE_REGION_ID = "tempRegionId";
export const COOKIE_REGION = "tempRegion";
export const COOKIE_LANG_ID = "tempLangId";
export const EN_USER_INFO = "metadataen";
export const LOC_USER_INFO = "metadata";
export const USER_LANG = "defaultlanguageid";
export const GLOBAL_REGION_ID = "globalRegionId";
